// extracted by mini-css-extract-plugin
module.exports = {"table-container":"RrTable_table-container__1KxgW","table":"RrTable_table__g5f8s"};